function numberFormat(number, decimals, decPoint, thousandsSep) {
  const num = (`${number}`).replace(/[^0-9+\-Ee.]/g, '');
  const n = !Number.isFinite(+num) ? 0 : +num;
  const precision = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals);
  const separator = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
  let formattedNumber = '';
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  if (precision) {
    const k = 10 ** precision;
    formattedNumber = `${(Math.round(n * k) / k).toFixed(precision)}`;
  } else {
    formattedNumber = `${Math.round(n)}`;
  }

  formattedNumber = formattedNumber.split('.');
  if (formattedNumber[0].length > 3) {
    formattedNumber[0] = formattedNumber[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, separator);
  }
  if ((formattedNumber[1] || '')
    .length < precision) {
    formattedNumber[1] = formattedNumber[1] || '';
    formattedNumber[1] += new Array((precision - formattedNumber[1].length) + 1).join('0');
  }

  return formattedNumber.join(dec);
}

/**
 * Prepends 0 on single digit numbers.
 *
 * @param number Number to process.
 */
function doubleDigit(number) {
  if (parseInt(number, 10) < 10) {
    return `0${number}`;
  }
  return number;
}

export { numberFormat, doubleDigit };
